import { setupWorker } from 'msw/browser';
import { promoHandlers } from './index';

export const worker = setupWorker(...promoHandlers);
